import React from "react";
import { useDataManagementFiles } from "@/hooks/useDataManagementFiles";
import { useOrg } from "@/hooks/useOrg";
import { DataManagementHeader } from "./DataManagementHeader";
import { DataManagementTable } from "./DataManagementTable";
import { useDataManagementPagination } from "./useDataManagementPagination";
import { useDataManagementFileOperations } from "./useDataManagementFileOperations";

export const DataManagementOverview = () => {
  const { org } = useOrg();
  const { pageIndex, after, before, handleNextPage, handlePreviousPage } =
    useDataManagementPagination();

  const {
    data: files,
    loading,
    refetch,
    totalCount,
    hasNextPage,
    hasPreviousPage,
    endCursor,
    startCursor,
  } = useDataManagementFiles({
    orgId: org?.id,
    first: after || (!after && !before) ? 10 : undefined,
    after: after || undefined,
    before: before || undefined,
  });

  const { handleDownload } = useDataManagementFileOperations(refetch);

  return (
    <div>
      <DataManagementHeader onFileUploaded={refetch} />
      <DataManagementTable
        files={files || []}
        loading={loading}
        totalCount={totalCount || 0}
        pageIndex={pageIndex}
        hasNextPage={hasNextPage || false}
        hasPreviousPage={hasPreviousPage || false}
        onNextPage={() => handleNextPage(endCursor)}
        onPreviousPage={() => handlePreviousPage(startCursor)}
        onDownload={handleDownload}
      />
    </div>
  );
};
